import './styles/tokens.css';
import './styles/base.css';
import './styles/play.css';
import './styles/screens.css';

import { boot } from './app';

boot();

// Register the service worker after first paint, so it never competes with the
// initial render. Failures are silent: an unregistered worker only costs cache.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch(() => {});
  });
}
